// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","modal":"App_modal__jwAA2"};